import { useRef } from 'react'
import type ReactECharts from 'echarts-for-react'
import { useEconomicHazardData } from '../../../hooks/useEconomicHazardData'
import EconomicHazardChart from '../../../chart/EconomicHazardChart'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import type {
  PropertiesQueryParams,
  PropertiesMetricOption,
} from '../../../types/riskProfileProperties.types'

export interface EconomicHazardsWidgetProps {
  queryParams: PropertiesQueryParams | null
  metricOption: PropertiesMetricOption
  entityNoun: string
}

export function EconomicHazardsWidget({
  queryParams,
  metricOption,
  entityNoun,
}: EconomicHazardsWidgetProps) {
  const { request, query } = useEconomicHazardData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request, '/report/risk-profile/properties/xlsx')
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, `${entityNoun}-disrupted-by-hazard`)

  return (
    <RiskProfileCard
      title={`Number of ${entityNoun} disrupted by hazard type`}
      description={`Number of ${entityNoun} disrupted by hazard type.`}
      onExport={
        <ChartExportActions
          onExportXlsx={exportXlsx}
          onExportImage={handleExportImage}
          isExportingXlsx={isExporting}
          xlsxDisabled={!request}
        />
      }
      className="min-h-96"
    >
      <ChartQueryState query={query}>
        {(data) => (
          <EconomicHazardChart
            ref={chartRef}
            data={data}
            metricOption={metricOption}
            entityNoun={entityNoun}
          />
        )}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
